export type FaroGeoAttributes = {
  country?: string;
  region?: string;
};

const ISO_COUNTRY_CODE = /^[A-Z]{2}$/;
const ISO_SUBDIVISION_CODE = /^[A-Z]{2}-[A-Z0-9]{1,3}$/;

/**
 * Returns coarse ISO geo attributes suitable for Faro session metadata.
 * Invalid values are omitted to keep arbitrary cookie values out of telemetry.
 */
export function buildFaroGeoAttributes(
  detectedCountry: string | null,
  detectedRegion: string | null
): FaroGeoAttributes {
  const country = detectedCountry?.trim().toUpperCase();
  const region = detectedRegion?.trim().toUpperCase();
  const attributes: FaroGeoAttributes = {};

  if (country && ISO_COUNTRY_CODE.test(country)) {
    attributes.country = country;
  }

  if (
    region &&
    ISO_SUBDIVISION_CODE.test(region) &&
    attributes.country &&
    region.startsWith(`${attributes.country}-`)
  ) {
    attributes.region = region;
  }

  return attributes;
}
